<template>
  <div class="header">
    <el-menu :default-active="this.pathname"
             class="el-menu"
             mode="horizontal"
             text-color="#A6A6A6"
             active-text-color="#fff"
             router>
      <template>
        <!-- 当该值与router的根路由的name相等时加载相应菜单组 -->
        <!--判断session中的值，pathname与pathname1两个值，pathname1为持久化存在的-->
        <!--            <template v-if="issue.name === pathname || issue.name === pathname1">-->
        <!--                      <template v-for="item in issue.children">-->
        <el-menu-item v-for="issue in $router.options.routes[1].children" :index="issue.path">
          <span slot="title">{{issue.name}}</span>
        </el-menu-item>
        <!--                      </template>-->
        <!--            </template>-->
      </template>
    </el-menu>
    <div align="center" class="logoBackground"><img src="../../static/img/kamaLOGO.png" class="logoImg"></div>

  </div>
</template>

<script>
    export default {
        name: "Header",
        data() {
            return {
                initPath: "",
                pathname: "",
                isFirst: true,//浏览器刷新标识，控制页面刷新导致session值变化
            }
        },
        methods: {
            defaultLeftNavOpened() {
                let cur_path = this.$route.path; //获取当前路由
                if (this.isFirst || sessionStorage.getItem("name") === 'undefined') {
                    sessionStorage.setItem("name", cur_path);//将获取到的参数存入session
                    this.isFirst = false
                }
                this.pathname = cur_path;
                let routers = this.$router.options.routes[1].children; // 获取路由对象
                for (let i = 0; i < routers.length; i++) {//遍历所有父路由
                    if (cur_path === routers[i].path) {//匹配与后端传入角色主页值一致的父路由
                        let newRuoter = routers[i];
                        this.initPath = newRuoter.path;
                        break;
                    }
                }
            }
        },
        mounted() {
            this.defaultLeftNavOpened();
        },
    }
</script>

<style scoped>
  .header {
    position: relative;
    height: 80px;
    width: 100%;
    min-width: 1366px;
    color: #fff;
    line-height: 80px;
  }

  .el-menu {
    height: 80px;
    border: 3px;
    background-color: #144685;
  }

  .el-menu--horizontal >>> .el-menu-item {
    font-size: 20px;
    height: 80px;
    line-height: 80px;
    padding: 0 35px;
    caret-color: transparent; /*取消输入光标*/
    border-bottom: 0;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border: 0;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background-color: #005e9e;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
    background-color: #144685;
  }

  .logoBackground {
    width: 400px;
    height: 85px;
    background-color: #fff;
    border-radius: 60px 0 0;
    position: absolute;
    top: 20px;
    right: 0;
    line-height: 85px;
    z-index: 999;
  }

  .logoImg {
    float: right;
    height: 95px;
    margin-top: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/Common/headerList.vue